import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar, { sizes } from '@hig/avatar';
import { createCustomClassNames, combineEventHandlers } from '@hig/utils';
import { css, cx } from 'emotion';
import Flyout, { AVAILABLE_ANCHOR_POINTS } from '@hig/flyout';
export { anchorPoints, AVAILABLE_ANCHOR_POINTS } from '@hig/flyout';
import ThemeContext from '@hig/theme-context';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function stylesheet(props, themeData) {
  var customStylesheet = props.stylesheet;

  var styles = {
    profileFlyoutButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      width: "32px",
      height: "32px",
      padding: 0,
      margin: 0,
      border: 0,
      outline: 0,
      background: "none",
      cursor: "pointer"
    },
    profileContent: {
      fontFamily: "ArtifaktElement",
      lineHeight: 1.6,
      boxSizing: "border-box",
      padding: themeData ? themeData["density.spacings.small"] : 0
    },
    profileName: _extends({
      display: "block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontSize: "16px",
      fontWeight: "bold",
      lineHeight: "24px"
    }, themeData ? { color: themeData["colorScheme.text.default"] } : {}),
    profileEmail: _extends({
      display: "block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontSize: "12px",
      lineHeight: "16px"
    }, themeData ? { color: themeData["colorScheme.text.dim"] } : {})
  };

  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ProfileButtonPresenter(_ref) {
  var avatarImage = _ref.avatarImage,
      avatarName = _ref.avatarName,
      onClick = _ref.onClick,
      customStylesheet = _ref.stylesheet,
      otherProps = _objectWithoutProperties(_ref, ["avatarImage", "avatarName", "onClick", "stylesheet"]);

  var className = otherProps.className;

  var profileFlyoutButtonClassName = createCustomClassNames(className, "profile-flyout-button");
  var profileFlyoutAvatarClassName = createCustomClassNames(className, "profile-flyout-avatar");
  var styles = stylesheet({ stylesheet: customStylesheet });

  return React.createElement(
    "button",
    {
      type: "button",
      className: cx(profileFlyoutButtonClassName, css(styles.profileFlyoutButton)),
      onClick: onClick
    },
    React.createElement(Avatar, {
      className: profileFlyoutAvatarClassName,
      image: avatarImage,
      name: avatarName,
      size: sizes.MEDIUM_32
    })
  );
}

ProfileButtonPresenter.propTypes = {
  /** Url to a profile image */
  avatarImage: PropTypes.string,
  /** The name that will converted into initials, and displayed when an image isn't available */
  avatarName: PropTypes.string,
  /** Callback when the flyout is opened */
  onClick: PropTypes.func,
  /** Function to modify the component's styles */
  stylesheet: PropTypes.func
};
ProfileButtonPresenter.__docgenInfo = {
  "description": "",
  "displayName": "ProfileButtonPresenter",
  "props": {
    "avatarImage": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Url to a profile image"
    },
    "avatarName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The name that will converted into initials, and displayed when an image isn't available"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback when the flyout is opened"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    }
  }
};

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileFlyout = function (_Component) {
  _inherits(ProfileFlyout, _Component);

  function ProfileFlyout() {
    _classCallCheck(this, ProfileFlyout);

    return _possibleConstructorReturn(this, (ProfileFlyout.__proto__ || Object.getPrototypeOf(ProfileFlyout)).apply(this, arguments));
  }

  _createClass(ProfileFlyout, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          alterCoordinates = _props.alterCoordinates,
          anchorPoint = _props.anchorPoint,
          avatarImage = _props.avatarImage,
          avatarName = _props.avatarName,
          children = _props.children,
          fallbackAnchorPoints = _props.fallbackAnchorPoints,
          onProfileClickOutside = _props.onProfileClickOutside,
          onProfileImageClick = _props.onProfileImageClick,
          open = _props.open,
          panel = _props.panel,
          stylesheet = _props.stylesheet,
          otherProps = _objectWithoutProperties$1(_props, ["alterCoordinates", "anchorPoint", "avatarImage", "avatarName", "children", "fallbackAnchorPoints", "onProfileClickOutside", "onProfileImageClick", "open", "panel", "stylesheet"]);

      var className = otherProps.className;


      return React.createElement(
        Flyout,
        {
          alterCoordinates: alterCoordinates,
          anchorPoint: anchorPoint,
          className: className,
          content: children,
          fallbackAnchorPoints: fallbackAnchorPoints,
          onClickOutside: onProfileClickOutside,
          open: open,
          panel: panel,
          stylesheet: stylesheet
        },
        function (_ref) {
          var handleClick = _ref.handleClick;
          return React.createElement(ProfileButtonPresenter, {
            avatarImage: avatarImage,
            avatarName: avatarName,
            className: className,
            onClick: combineEventHandlers(handleClick, onProfileImageClick),
            stylesheet: stylesheet
          });
        }
      );
    }
  }]);

  return ProfileFlyout;
}(Component);

ProfileFlyout.propTypes = {
  /** Manipulate flyout coordinates before each render */
  alterCoordinates: PropTypes.func,
  /** Where the flyout will be anchored relative to target */
  anchorPoint: PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS),
  /** Url pointing to signed in user's avatar image */
  avatarImage: PropTypes.string,
  /** Signed-in user's name */
  avatarName: PropTypes.string,
  /** Content to be rendered inside the flyout */
  children: PropTypes.node,
  /**
   * When the flyout overflows the viewport, it'll attempt to
   * use the given anchor points in order to keep the flyout
   * within the viewport.
   */
  fallbackAnchorPoints: PropTypes.arrayOf(PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS)),
  /** Called when user clicks away from the profile flyout */
  onProfileClickOutside: PropTypes.func,
  /** Called when user clicks the profile image */
  onProfileImageClick: PropTypes.func,
  /** Shows or hides the flyout */
  open: PropTypes.bool,
  /** Renders a custom flyout panel. Can be either a node or a render function */
  panel: PropTypes.func,
  /** Function to modify the component's styles */
  stylesheet: PropTypes.func
};
ProfileFlyout.defaultProps = {
  panel: function panel(_ref2) {
    var content = _ref2.content,
        innerRef = _ref2.innerRef;
    return React.createElement(
      Flyout.Panel,
      { innerRef: innerRef },
      content
    );
  }
};
ProfileFlyout.__docgenInfo = {
  "description": "",
  "displayName": "ProfileFlyout",
  "props": {
    "alterCoordinates": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Manipulate flyout coordinates before each render"
    },
    "anchorPoint": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ANCHOR_POINTS"
      },
      "required": false,
      "description": "Where the flyout will be anchored relative to target"
    },
    "avatarImage": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Url pointing to signed in user's avatar image"
    },
    "avatarName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Signed-in user's name"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Content to be rendered inside the flyout"
    },
    "fallbackAnchorPoints": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "enum",
          "computed": true,
          "value": "AVAILABLE_ANCHOR_POINTS"
        }
      },
      "required": false,
      "description": "When the flyout overflows the viewport, it'll attempt to\nuse the given anchor points in order to keep the flyout\nwithin the viewport."
    },
    "onProfileClickOutside": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user clicks away from the profile flyout"
    },
    "onProfileImageClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user clicks the profile image"
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Shows or hides the flyout"
    },
    "panel": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Renders a custom flyout panel. Can be either a node or a render function",
      "defaultValue": {
        "value": "({ content, innerRef }) => (\n  <Flyout.Panel innerRef={innerRef}>{content}</Flyout.Panel>\n)",
        "computed": false
      }
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    }
  }
};

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ProfileContentPresenter(props) {
  var children = props.children,
      profileEmail = props.profileEmail,
      profileName = props.profileName,
      customStylesheet = props.stylesheet,
      otherProps = _objectWithoutProperties$2(props, ["children", "profileEmail", "profileName", "stylesheet"]);

  var className = otherProps.className;

  var profileNameClassName = createCustomClassNames(className, "profile-name");
  var profileEmailClassName = createCustomClassNames(className, "profile-email");

  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref) {
      var resolvedRoles = _ref.resolvedRoles;

      var styles = stylesheet({ stylesheet: customStylesheet }, resolvedRoles);

      return React.createElement(
        "div",
        { className: cx(className, css(styles.profileContent)) },
        profileName ? React.createElement(
          "span",
          {
            className: cx(profileNameClassName, css(styles.profileName))
          },
          profileName
        ) : null,
        profileEmail ? React.createElement(
          "span",
          {
            className: cx(profileEmailClassName, css(styles.profileEmail))
          },
          profileEmail
        ) : null,
        children
      );
    }
  );
}

ProfileContentPresenter.propTypes = {
  /** Profile actions */
  children: PropTypes.node,
  /** The displayed email */
  profileEmail: PropTypes.string,
  /** The displayed name */
  profileName: PropTypes.string,
  /** Function to modify the component's styles */
  stylesheet: PropTypes.func
};
ProfileContentPresenter.__docgenInfo = {
  "description": "",
  "displayName": "ProfileContentPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Profile actions"
    },
    "profileEmail": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The displayed email"
    },
    "profileName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The displayed name"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    }
  }
};

export default ProfileFlyout;
export { ProfileContentPresenter as ProfileContent };
